$shm_sort $mol_list
	options *
	sort_by? \
	sub /
		<= Options $mol_list
			sub <= option_views /
				<= Option*0 $shm_sort_item
					click? <=> option_click*? null
					sort_order? <=> sort_order? \
					title <= option_label* \
					selected <= option_selected* false

$shm_sort_item $mol_button_minor
	sort_order? \desc
	sub /
		^ icon /
			- <= Descending $mol_icon_sort_descending
			<= Descending $mol_icon_sort_ascending
			<= Ascending $mol_icon_sort_ascending
		<= title
	attr *
		^
		selected <= selected false
